<template>
  <div class="footer-deco">
    <!-- <div class="decoration">
      <svg class="left-deco">
        <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-left.svg#main'" />
      </svg>
      <svg class="right-deco">
        <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-right.svg#main'" />
      </svg>
    </div> -->
    <slot>
      <div class="action">
        <h4 class="use-text-title2">
          <span v-t="'copy.footerHeadline'" />
        </h4>
        <v-btn color="secondary" large :to="{ name: 'register' }">
          <span v-t="'Get Started'" />
        </v-btn>
      </div>
    </slot>
    <!-- <footer-main /> -->
    <FooterMinimal ></FooterMinimal>
  </div>
</template>

<style lang="scss" scoped>
@import "./footer-style.scss";
</style>

<script>
import FooterMinimal from "./FooterMinimal";
import Footer from "./Footer";

export default {
  components: {
    "footer-main": Footer,
    FooterMinimal,
  },
};
</script>
